import Library from "../components/Library";
import useAuth from "../../Users/hooks/useAuth";
import Login from "../../Users/Login";
import ForgotPassword from "../../Users/ForgotPw";
import Concept from "../components/Concept";
import HowTo from "../components/HowTo";
import TeametAbout from "../components/TeametAbout";
import Register from "../../Users/Register";
import { useEffect, useState } from "react";

const Entry = () => {
    const { auth, setAuth } = useAuth();
    const [forgotPass, setForgotPass] = useState(false)
    const [register, setRegister] = useState(false)
    const [showTeam, setShowTeam] = useState(false)

    const checkToken = async () => {
        const token = localStorage.getItem("token");
        if (token && !auth?.email) {
            const response = await fetch(`${process.env.REACT_APP_USER_API_URL}/users/me`, {
                method: "GET",
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${token}`,
                },
              });
            if (response.ok) {
                let userData = await response.json();
                userData["token"] = token;
                setAuth(userData);
            }
        }
    }

    useEffect(() => { checkToken() });

    if (!auth?.email) {
        return (
            <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100">
                {/* Full Screen Team Modal - No Padding */}
                {showTeam && (
                    <div className="fixed inset-0 bg-black bg-opacity-50 z-50">
                        <div className="bg-white w-full h-full overflow-y-auto">
                            <div className="sticky top-0 bg-white border-b border-gray-200 px-8 py-4 flex justify-between items-center z-10 shadow-sm">
                                <h2 className="text-2xl lg:text-3xl font-bold text-gray-800 font-mono">Our Team</h2>
                                <button 
                                    onClick={() => setShowTeam(false)}
                                    className="w-10 h-10 bg-gray-100 hover:bg-gray-200 rounded-full flex items-center justify-center transition-colors text-lg hover:scale-110"
                                >
                                    ✕
                                </button>
                            </div>
                            <div className="w-full">
                                <TeametAbout />
                            </div>
                        </div>
                    </div>
                )}

                {/* Header */}
                <div className="bg-white/80 backdrop-blur-sm border-b border-gray-200 shadow-sm">
                    <div className="w-full px-4 sm:px-6 py-8 text-center">
                        <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent font-mono mb-4">
                            The Catchphraser
                        </h1>
                        <p className="text-lg sm:text-xl lg:text-xl text-gray-600 font-mono font-medium mb-2">
                            A novel approach to pronunciation training
                        </p>
                        <div className="flex flex-col sm:flex-row justify-center items-center gap-4 text-sm sm:text-base">
                            <p className="text-blue-500 flex items-center">
                                <span className="mr-2">📧</span>
                                info@catchphraser.com
                            </p>
                            <p className="text-amber-500 flex items-center">
                                <span className="mr-2">⚠️</span>
                                Tested on PC, Mac, Android (Chrome/Opera)
                            </p>
                        </div>
                    </div>
                </div>

                {/* Main Content - Minimal Padding */}
                <div className="w-full px-4 sm:px-6 py-8">
                    <div className="flex flex-col xl:flex-row gap-8 max-w-[1800px] mx-auto">
                        {/* Login/Register Section */}
                        <div className="xl:w-1/4 2xl:w-1/5 min-h-0">
                             <div className="bg-white rounded-2xl shadow-lg border border-gray-200 p-6 xl:sticky xl:top-6 min-h-0 xl:max-h-[calc(100vh-3rem)] xl:overflow-y-auto">
                                  {register ? (
                                    <Register successHandler={(state) => { setRegister(state) }} />
                                ) : forgotPass ? (
                                    <ForgotPassword forgotPassHandler={(state) => { setForgotPass(state) }} />
                                ) : (
                                    <Login 
                                        forgotPassHandler={(state) => { setForgotPass(state) }}
                                        registerHandler={(state) => { setRegister(state) }}
                                    />
                                )}
                            </div>
                        </div>

                        {/* Content Sections - More Space */}
                        <div className="xl:w-3/4 2xl:w-4/5">
                            <div className="grid xl:grid-cols-4 gap-8">
                                {/* Main content blocks - takes 3/4 of the space */}
                                <div className="xl:col-span-3 space-y-8">
                                    <Concept />
                                    <HowTo />
                                </div>
                                
                                {/* Team Mini Column */}
<div className="xl:col-span-1">
  <div className="bg-gradient-to-br from-blue-50 to-purple-50 rounded-2xl shadow-lg border border-blue-200 p-6 sticky top-6">
    <div className="text-center mb-6">
      <h2 className="text-xl font-bold text-gray-800 font-mono mb-2">
        Our Team
      </h2>
      <div className="w-16 h-1 bg-gradient-to-r from-blue-500 to-purple-500 mx-auto rounded-full mb-4"></div>
    </div>
    
    <div className="space-y-4">
      <div className="text-center">
        <p className="text-gray-600 text-sm leading-relaxed mb-4">
          Language learning experts focused on helping you master pronunciation and speech rhythm
        </p>
      </div>

     

      {/* Expand Button */}
      <button 
        onClick={() => setShowTeam(true)}
        className="w-full bg-gradient-to-r from-blue-500 to-purple-500 hover:from-blue-600 hover:to-purple-600 text-white font-semibold py-3 px-4 rounded-lg transition-all duration-200 transform hover:scale-105 shadow-md mt-4"
      >
        Meet Our Team
      </button>
    </div>
  </div>
</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return <Library />;
}

export default Entry;